import axios from 'axios';
import humps from 'humps';
import queryString from 'query-string';
import { API_URL } from '../config';

const getInsuranceTableData = (userId, params, filters, path) => {
  const {
    page = 1,
    limit: perPage = 10,
    order = 'desc',
    sortBy = 'created_at',
  } = params;

  const pimpFilterBy = {};

  /** filters obj can contain contractId,firstName,lastName,email,mobilePhone,amount,fromDate,toDate
     *    if key exists but has no value(empty string) ->
     do nothing (first if)
     *    if value exists and key is 'created_at[]' ->
     save that value to datafilter obj with 'created_at[]' key
     *    otherwise ->
     save the value to pimpFilterBy obj with snakeCased key (contractId -> contract_id)
     */

  Object.keys(filters).forEach((key) => {
    const val = filters[key];
    const camelKey = humps.decamelize(key);

    if (val) {
      pimpFilterBy[camelKey] = camelKey.endsWith('[]') ? val : `%${val}%`;
    }
  });

  const pimpSortBy = sortBy === 'fullName' ? 'first_name' : `${humps.decamelize(sortBy)}`;

  const paramsToStringify = {
    ...pimpFilterBy,
    page,
    perPage,
    'sort[]': `${pimpSortBy},${order}`,
  };

  const URL = `${API_URL}/user/${userId}/${path}`;

  return axios
    .get(`${URL}?${queryString.stringify(paramsToStringify)}`)
    .then((response) => response.data);
};

export const fetchDraftTravelInsuranceList = (userId, params, filters = {}) => getInsuranceTableData(userId, params, filters, 'draft-travel-contract')
  .then((data) => {
    const result = [];
    Object.keys(data).forEach((i) => {
      result.push({
        ...data[i],
      });
    });

    return {
      data: result.filter((c) => c.draftId),
    };
  });

export const fetchDraftPropertyInsuranceList = (userId, params, filters = {}) => getInsuranceTableData(userId, params, filters, 'draft-property-contract')
  .then((data) => {
    const result = [];
    Object.keys(data).forEach((i) => {
      result.push({
        ...data[i],
        limit: data[i].plan && data[i].plan.selected,
      });
    });

    return {
      data: result.filter((c) => c.draftId),
    };
  });

export const fetchPropertyInsuranceList = (userId, params, filters = {}) => getInsuranceTableData(userId, params, filters, 'property-contract');
export const fetchTravelInsuranceList = (userId, params, filters = {}) => getInsuranceTableData(userId, params, filters, 'travel-contract');
export const fetchCMTPLInsuranceList = (userId, params, filters = {}) => getInsuranceTableData(userId, params, filters, 'appa-contract');
export const fetchCMTPLCascoInsuranceList = (userId, params, filters = {}) => getInsuranceTableData(userId, params, filters, 'appacasco-contract');
export const fetchVMTPLInsuranceList = (userId, params, filters = {}) => getInsuranceTableData(userId, params, filters, 'appka-contract');
